import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'clemos-institution',
  templateUrl: './institution.component.html',
  styleUrls: ['./institution.component.scss']
})
export class InstitutionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
